import { LangLocale, languages } from '@myre/common-i18n';
import {
  LANGLOCALE,
  SafeUrlPipe,
  TranslatePipe,
} from '@myre/ui-primitive-core';

import { Component, inject, Input } from '@angular/core';

import { getTypeFromExtension } from './doc-viewer.helper';
import { PdfJsViewerComponent } from './ng2-pdfjs-viewer/src/ng2-pdfjs-viewer.component';

@Component({
  selector: 'myre-doc-viewer',
  templateUrl: './doc-viewer.component.html',
  styleUrls: ['./doc-viewer.component.scss'],
  imports: [PdfJsViewerComponent, SafeUrlPipe, TranslatePipe],
})
export class DocViewerComponent {
  @Input()
  public src: string;

  @Input()
  public set extension(extension: string) {
    if (!extension) {
      return;
    }

    this._extension = extension;
    this.type = getTypeFromExtension(extension);
  }

  public get extension(): string {
    return this._extension;
  }

  public type: 'img' | 'pdf';
  public locale: string;

  private _extension: string;

  constructor() {
    const langLocale = inject<LangLocale>(LANGLOCALE);

    this.locale = languages[langLocale].intlLocale;
  }

  public getPdfSrc(): string {
    return encodeURIComponent(this.src);
  }
}
